import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthResult } from '../services/AuthService';
import { LoginResponseLocalStorageKey } from '../services/BackendService';
import { getItem } from '../services/LocalStorageService';
import { baseURL } from '../services/BackendService';

const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers) => {
      const authResult: AuthResult | null = getItem(LoginResponseLocalStorageKey);
      if (authResult) {
        headers.set('Authorization', `${authResult.token}`);
      }
    },
  }),
  endpoints: () => ({}),
  tagTypes: ['Coupon', 'EventType', 'FeatureFlags', 'Incident'],
});

export default api;
